import React from "react";
const EventFields = ({ fields }) => {
  const fieldNames = Object.keys(fields);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, fieldNames.map((fieldName) => /* @__PURE__ */ React.createElement("div", { key: fieldName }, /* @__PURE__ */ React.createElement("b", null, fieldName), " ", fields[fieldName])));
};
export default EventFields;
